export const HOME = "/";
export const SERVICES = "/services";
export const REALISATIONS = "/realisations";
export const PROFILE = "/florian-da-cunha-developpeur-fullstack";
export const ABOUT = "/a-propos";
export const CONTACT = "/contact";
export const RDV = "/rdv";
export const BLOG = "/blog";
export const PRIVACY = "/privacy-policy";
export const TERMS = "/terms";
export const HELP = "/help";

// Legacy offer sub-pages kept only as redirect sources.
export const OFFER_SITES_WEB = "/offers/sites-web";
export const OFFER_SAAS = "/offers/saas";
export const OFFER_MOBILE = "/offers/mobile";
export const OFFER_GROWTH = "/offers/growth";

export const REALISATION_DETAIL_PATTERN = `${REALISATIONS}/:slug`;
export const BLOG_ARTICLE_PATTERN = `${BLOG}/:articleId`;

export const realisationDetail = (slug) => `${REALISATIONS}/${slug}`;
export const blogArticle = (articleId) => `${BLOG}/${articleId}`;
